import ApiService from '@api/api-service';

export const url = '/api/cart';
export default new ApiService(url);
